var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isshow)?_c('div',{staticClass:"context"},[_c('span',{staticClass:"tip",class:_vm.Backwards === '-1' ? '' : 'back'},[_vm._v(_vm._s(_vm.text))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }